import theme from "../index";

export const cardIconSx = {
  width: 36,
  height: 36,
  borderRadius: "12px",
  backgroundColor: "#FF3100",
  color: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const selectSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: `${theme.radius.medium}px`,
    fontSize: 15, // tamanho do texto no input
    height: "40px",
  },
  "& .MuiInputBase-input": {
    fontSize: 15,
  },
};

export const permissionSwitchTheme = {
  components: {
    Switch: {
      colorPrimary: theme.colors.primary,
      colorPrimaryHover: theme.colors.primary,
      colorTextQuaternary: theme.colors.switchTrackOff,
      colorTextTertiary: theme.colors.switchTrackOffHover,
    },
  },
};

export const permissionLabelStyle = {
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.xs,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.bodySize,
  lineHeight: theme.typography.bodyLineHeight,
  color: theme.colors.textPrimary,
};

export const permissionCellStyle = {
  textAlign: "center",
  padding: `${theme.spacing.xxs + 2}px ${theme.spacing.xs}px`,
};

export const permissionThemeVars = {
  "--permission-primary": theme.colors.primary,
  "--permission-primary-soft": theme.colors.primarySoft,
  "--permission-primary-border": theme.colors.primaryBorder,
  "--permission-switch-track-off": theme.colors.switchTrackOff,
  "--permission-switch-track-off-hover": theme.colors.switchTrackOffHover,
  "--permission-switch-track-disabled": theme.colors.switchTrackDisabled,
  "--permission-text-primary": theme.colors.textPrimary,
  "--permission-spacing-xs": `${theme.spacing.xs}px`,
  "--permission-body-size": theme.typography.bodySize,
  "--permission-font-family": theme.typography.fontFamily,
  "--permission-motion": theme.motion.transition,
};
